import baseAPI from './axiosApi'

const api={
    list:'/api-ir/doctor/page',
    getPaper:'/api-ir/doctor/list/paper/',
    getSocial:'/api-ir/doctor/list/socialInfluence/',
    getReward:'/api-ir/doctor/list/reward/',
    getAcademic:'/api-ir/doctor/list/academicExchange/',
    getFund:'/api-ir/doctor/list/fund/',
    getMonograph:'/api-ir/doctor/list/monograph/',
    getPatent:'/api-ir/doctor/list/patent/',
    getResearch:'/api-ir/doctor/list/researchProject/',
    addPaper:'/api-ir/doctor/add/paper',
    addSocial:'/api-ir/doctor/add/socialInfluence',
    addReward:'/api-ir/doctor/add/reward',
    addAcademic:'/api-ir/doctor/add/academicExchange',
    addFund:'/api-ir/doctor/add/fund',
    addMonograph:'/api-ir/doctor/add/monograph',
    addPatent:'/api-ir/doctor/add/patent',
    addResearch:'/api-ir/doctor/add/researchProject',
    updatePaper:'/api-ir/doctor/edit/paper',
    updateSocial:'/api-ir/doctor/edit/socialInfluence',
    updateReward:'/api-ir/doctor/edit/reward',
    updateAcademic:'/api-ir/doctor/edit/academicExchange',
    updateFund:'/api-ir/doctor/edit/fund',
    updateMonograph:'/api-ir/doctor/edit/monograph',
    updatePatent:'/api-ir/doctor/edit/patent',
    updateResearch:'/api-ir/doctor/edit/researchProject',
    check:"/api-ir/doctor/",
    del:'/api-ir/doctor/delete/'

}

export function list (data) {
    return baseAPI.axiosData(api.list,'get',data)
}

export function getPaper (data) {
    return baseAPI.axiosData(api.getPaper+data,'get')
}
export function getSocial (data) {
    return baseAPI.axiosData(api.getSocial+data,'get')
}
export function getReward (data) {
    return baseAPI.axiosData(api.getReward+data,'get')
}
export function getAcademic (data) {
    return baseAPI.axiosData(api.getAcademic+data,'get')
}
export function getFund (data) {
    return baseAPI.axiosData(api.getFund+data,'get')
}
export function getMonograph (data) {
    return baseAPI.axiosData(api.getMonograph+data,'get')
}
export function getPatent (data) {
    return baseAPI.axiosData(api.getPatent+data,'get')
}
export function getResearch (data) {
    return baseAPI.axiosData(api.getResearch+data,'get')
}

export function addPaper (data) {
    return baseAPI.axiosData(api.addPaper,'post',data)
}
export function addSocial (data) {
    return baseAPI.axiosData(api.addSocial,'post',data)
}
export function addReward (data) {
    return baseAPI.axiosData(api.addReward,'post',data)
}
export function addAcademic (data) {
    return baseAPI.axiosData(api.addAcademic,'post',data)
}
export function addFund (data) {
    return baseAPI.axiosData(api.addFund,'post',data)
}
export function addMonograph (data) {
    return baseAPI.axiosData(api.addMonograph,'post',data)
}
export function addPatent (data) {
    return baseAPI.axiosData(api.addPatent,'post',data)
}
export function addResearch (data) {
    return baseAPI.axiosData(api.addResearch,'post',data)
}

export function updatePaper (data) {
    return baseAPI.axiosData(api.updatePaper,'put',data)
}
export function updateSocial (data) {
    return baseAPI.axiosData(api.updateSocial,'put',data)
}
export function updateReward (data) {
    return baseAPI.axiosData(api.updateReward,'put',data)
}
export function updateAcademic (data) {
    return baseAPI.axiosData(api.updateAcademic,'put',data)
}
export function updateFund (data) {
    return baseAPI.axiosData(api.updateFund,'put',data)
}
export function updateMonograph (data) {
    return baseAPI.axiosData(api.updateMonograph,'put',data)
}
export function updatePatent (data) {
    return baseAPI.axiosData(api.updatePatent,'put',data)
}
export function updateResearch (data) {
    return baseAPI.axiosData(api.updateResearch,'put',data)
}

export function check (doctorReward,approve,data) {
    return baseAPI.axiosData(api.check+doctorReward+'/'+approve,'post',data)
}

export function del (doctorReward,id) {
    return baseAPI.axiosData(api.del+doctorReward+'/'+id,'delete')
}
